import React, { useState } from "react";
import styles from "./DropdownField.module.scss";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface DropdownFieldProps {
    label: string;
    children: React.ReactNode;
    open?: boolean; // default (iniziale)
}

const DropdownField: React.FC<DropdownFieldProps> = ({ label, children, open = false }) => {
    const [isOpen, setIsOpen] = useState(open);

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div className={styles.dropdownWrapper}>
            <div className={styles.dropdownHeader} onClick={handleToggle}>
                <span className={styles.dropdownLabel}>{label}</span>
                <span className={styles.dropdownIcon}>
          {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </span>
            </div>
            {isOpen && <div className={styles.dropdownContent}>{children}</div>}
        </div>
    );
};

export default DropdownField;